import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Helmet } from 'react-helmet';
import * as DataList from 'components/DataList';
import SettingsPage from 'components/SettingsPage';
import PaymentMethodTable, {
  PAYMENT_METHOD_COLUMNS, PAYMENT_METHOD_CARDS, PAYMENT_METHOD_MIN_TABLE_WIDTH,
} from 'components/Tables/PaymentMethod';

// Settings > Payment methods (/payment_methods). There's no Add here: payment
// methods aren't created from this screen (the old Add button was switched off).
@inject('paymentMethodStore') @observer
class PaymentMethodIndexPage extends Component {

  componentDidMount() {
    this.props.paymentMethodStore.loadPaymentMethods();
  }

  render() {
    const { paymentMethodStore } = this.props;
    const { isLoading, isError, objects } = paymentMethodStore.paymentMethods;
    let content;
    if (isLoading) {
      content = (
        <DataList.Loading
          columns={PAYMENT_METHOD_COLUMNS}
          cards={PAYMENT_METHOD_CARDS}
          minTableWidth={PAYMENT_METHOD_MIN_TABLE_WIDTH}
          noun="payment methods"
          rows={4}
        />
      );
    } else if (isError) {
      content = <DataList.LoadError noFilters noun="payment methods" onRetry={() => paymentMethodStore.loadPaymentMethods()} />;
    } else if (objects) {
      content = <PaymentMethodTable />;
    }
    return (
      <React.Fragment>
        <Helmet>
          <title>Payment methods | FieldNexus</title>
        </Helmet>
        <SettingsPage
          title="Payment methods"
          description="How customers pay you, like cash or cheque. Match each one to a QuickBooks payment method to sync payments."
        >
          {content}
        </SettingsPage>
      </React.Fragment>
    );
  }
}

export default PaymentMethodIndexPage;
